var map = {
	"./de/seqwater/taxonomy.json": 3806,
	"./de/texas/taxonomy.json": 6151,
	"./en/seqwater/taxonomy.json": 1598,
	"./en/texas/taxonomy.json": 4598,
	"./fr/seqwater/taxonomy.json": 5573,
	"./fr/texas/taxonomy.json": 1817,
	"./th/seqwater/taxonomy.json": 3666,
	"./th/texas/taxonomy.json": 4791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7997;